<template>
  <OnlyOnClient>
    <TheModal class="modal-city" v-model:show="showModalValue">
      <div class="adress__body modal__body full">
        <div class="modal__close desctop" @click="setShowModal(false)">
          <svg width="32" height="32" viewBox="0 0 32 32" fill="none"
               xmlns="http://www.w3.org/2000/svg">
            <path d="M5.33333 5.33398L26.6667 26.6673M26.6667 5.33398L5.33333 26.6673" stroke="white" stroke-width="2"
                  stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        <div class="modal__close tablet" @click="setShowModal(false)">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
               xmlns="http://www.w3.org/2000/svg">
            <path d="M4 4L20 20M20 4L4 20" stroke="black" stroke-width="2" stroke-linecap="round"
                  stroke-linejoin="round"/>
          </svg>
        </div>
        <div class="card__body-wrapper">
            <TheShippingMethod/>
        </div>
      </div>
    </TheModal>
  </OnlyOnClient>
</template>

<script>
import OnlyOnClient from "@/components/OnlyOnClient.vue";

import {mapMutations, mapState} from "vuex";
import TheModal from "@/components/TheModal.vue";
import TheShippingMethod from "@/components/element/order/shipping/TheShippingMethod.vue";

export default {
  name: 'TheShippingModal',
  components: {TheShippingMethod, TheModal, OnlyOnClient},
  computed: {
    showModalValue: {
      get() {
        return this.showModal;
      },
      set(value) {
        this.setShowModal(value)
      }
    },
    ...mapState({
      'showModal': state => state.shipping.showModal,
    }),

  },

  methods: {
    ...mapMutations({
      'setShowModal': 'shipping/setShowModal',
    }),

  },
}
</script>

<style lang="scss" scoped>
.card__body-wrapper {
  height: 100%;
}
</style>